/**
 * Verifica si la primera fecha es menor que la segunda fecha por un tiempo específico
 * @param firstDate - Primera fecha en formato "YYYY/MM/DD HH:mm:ss"
 * @param secondDate - Segunda fecha en formato "YYYY/MM/DD HH:mm:ss"
 * @param timeDifferenceSeconds - Diferencia de tiempo en segundos (por defecto 120 = 2 minutos)
 * @returns true si la primera fecha es menor que la segunda por el tiempo especificado
 */
export function isDateOlderThan(
  firstDate: string,
  secondDate: string,
  timeDifferenceSeconds: number = 120
): boolean {
  try {
    // Convertir las fechas string a objetos Date
    const firstDateTime = new Date(firstDate.replace(/\//g, '-'));
    const secondDateTime = new Date(secondDate.replace(/\//g, '-'));

    // Verificar que las fechas sean válidas
    if (isNaN(firstDateTime.getTime()) || isNaN(secondDateTime.getTime())) {
      console.error('(isDateOlderThan) Formato de fecha inválido');
      return false;
    }

    // Calcular la diferencia en milisegundos
    const differenceMs = secondDateTime.getTime() - firstDateTime.getTime();
    const differenceSeconds = differenceMs / 1000;

    // Verificar si la primera fecha es menor que la segunda por el tiempo especificado
    return differenceSeconds >= timeDifferenceSeconds;
  } catch (error) {
    console.error('(isDateOlderThan) Error al procesar las fechas:', error);
    return false;
  }
}

/**
 * Verifica si la primera fecha es menor que la segunda fecha por 2 minutos (120 segundos)
 * @param firstDate - Primera fecha en formato "YYYY/MM/DD HH:mm:ss"
 * @param secondDate - Segunda fecha en formato "YYYY/MM/DD HH:mm:ss"
 * @returns true si la primera fecha es menor que la segunda por al menos 2 minutos
 */
export function isDateOlderThanTwoMinutes(
  firstDate: string,
  secondDate: string
): boolean {
  return isDateOlderThan(firstDate, secondDate, 120);
}
